import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// index page sections
import Download from "../sub_components/Download.js";

import { MultiLang, Determinator } from "react-multi-language";
import Navbar from "components_/sub_components/Navbar.js";

import ScrollIntoView from 'react-scroll-into-view'

class Events extends React.Component {
  state = {};
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
    console.log("..[log - WhatsNew.js (componentDidMount()), languageState] : ", this.props.languageState);
    console.log(this.props.languageState);
  };

  render() {
    return (
      <>
        <Navbar languageState={this.props.languageState} updateLanguageState={this.props.updateLanguageState} />
        {console.log("..[log - WhatsNew.js, languageState] : ", this.props.languageState)}
        {/* <DemoNavbar /> */}
        <main ref="main">
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="6">
                      <h1 className="display-3 text-white">
                        {/* Recent Activities{" "} */}
                        <Determinator>
                          {{
                            en: "What’s New",
                            tw: "最新動態",
                            cn: "最新动态",
                          }}
                        </Determinator>
                        {" "}
                        {/* <span>completed with examples</span> */}
                      </h1>
                      {/* <button onClick={() => { this.props.updateLanguageState({ lang: "param" }) }}>road to success</button> */}
                      <p className="lead text-white">
                        <Determinator>
                          {{
                            en: "Upcoming Events ",
                            tw: "近期活動",
                            cn: "近期活动",
                          }}
                        </Determinator>
                      </p>
                      {/* <div className="btn-wrapper">
                        <Button
                          className="btn-icon mb-3 mb-sm-0"
                          color="info"
                          href="https://demos.creative-tim.com/argon-design-system-react/#/documentation/alerts?ref=adsr-landing-page"
                        >
                          <span className="btn-inner--icon mr-1">
                            <i className="fa fa-code" />
                          </span>
                          <span className="btn-inner--text">Components</span>
                        </Button>
                        <Button
                          className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                          color="default"
                          href="https://www.creative-tim.com/product/argon-design-system-react?ref=adsr-landing-page"
                        >
                          <span className="btn-inner--icon mr-1">
                            <i className="ni ni-cloud-download-95" />
                          </span>
                          <span className="btn-inner--text">
                            Download React
                          </span>
                        </Button>
                      </div> */}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    
                    <Col lg="4">
                      <Card className=" shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="ni ni-istanbul" />
                          </div>
                          <h6 className="text-success text-uppercase">
                            <Determinator>
                              {{
                                en: "CLC Naming Competition",
                                tw: "社區聯絡中心命名比賽",
                                cn: "社区联络中心命名比赛",
                              }}
                            </Determinator>
                          </h6>
                          <p className="description mt-3">
                            {/* <Determinator>
                              {{
                                en: "coming soon...",
                                tw: "籌備中...",
                                cn: "筹备中...",
                              }}
                            </Determinator> */}
                          </p>
                          <div>
                            <Badge color="success" pill className="mr-1">
                              <Determinator>
                                {{
                                  en: "2020/10",
                                  tw: "2020/10",
                                  cn: "2020/10",
                                }}
                              </Determinator>
                            </Badge>
                            {/* <Badge color="success" pill className="mr-1">
                              individual
                            </Badge>
                            <Badge color="success" pill className="mr-1">
                              2020/11
                            </Badge> */}
                          </div>

                          <ScrollIntoView selector="#leaflet">
                            <Button
                              className="mt-4"
                              color="success"
                              href="#pablo"
                              onClick={e => e.preventDefault()}
                            >
                              <Determinator>
                                {{
                                  en: "more information",
                                  tw: "更多資訊",
                                  cn: "更多资讯",
                                }}
                              </Determinator>
                            </Button>
                          </ScrollIntoView>

                        </CardBody>
                      </Card>
                    </Col>

                    <Col lg="4">
                      <Card className="shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="ni ni-check-bold" />
                          </div>
                          <h6 className="text-primary text-uppercase">
                            <Determinator>
                              {{
                                en: "CLC Officially Opened on 17 Oct 2020!",
                                tw: "社區聯絡中心已於2020年10月17日正式啟用",
                                cn: "社区联络中心已於2020年10月17日正式启用",
                              }}
                            </Determinator>
                          </h6>
                          <p className="description mt-3">
                            {/* <Determinator>
                              {{
                                en: "Groundbreaking of CLC",
                                tw: "社區聯絡中心動土儀式",
                                cn: "社区联络中心动土仪式",
                              }}
                            </Determinator> */}
                          </p>
                          <div>
                            {/* <Badge color="primary" pill className="mr-1">
                              workshop
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              teenager
                            </Badge> */}
                            <Badge color="primary" pill className="mr-1">
                              2020/10
                            </Badge>
                          </div>
                          <ScrollIntoView selector="#newsletter">
                            <Button
                              className="mt-4"
                              color="primary"
                              href="#pablo"
                              onClick={e => e.preventDefault()}
                            >
                              <Determinator>
                                {{
                                  en: "Welcome to join us",
                                  tw: "歡迎參與",
                                  cn: "欢迎参与",
                                }}
                              </Determinator>
                            </Button>
                          </ScrollIntoView>
                        </CardBody>
                      </Card>
                    </Col>
                    
                    <Col lg="4">
                      <Card className=" shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                            <i className="ni ni-planet" />
                          </div>
                          <h6 className="text-warning text-uppercase">
                            <Determinator>
                              {{
                                en: "coming soon...",
                                tw: "籌備中...",
                                cn: "筹备中...",
                              }}
                            </Determinator>
                          </h6>
                          <p className="description mt-3">
                            {/* <Determinator>
                              {{
                                en: "coming soon...",
                                tw: "籌備中...",
                                cn: "筹备中...",
                              }}
                            </Determinator> */}
                          </p>
                          <div>
                            <Badge color="warning" pill className="mr-1">
                              <Determinator>
                                {{
                                  en: "coming soon...",
                                  tw: "籌備中...",
                                  cn: "筹备中...",
                                }}
                              </Determinator>
                            </Badge>
                            {/* <Badge color="warning" pill className="mr-1">
                              family
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              2020/12
                            </Badge> */}
                          </div>
                          <Button
                            className="mt-4"
                            color="warning"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <Determinator>
                              {{
                                en: "coming soon...",
                                tw: "籌備中...",
                                cn: "筹备中...",
                              }}
                            </Determinator>
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          {/* <section className="section section-lg">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid floating"
                    src={require("assets/img/theme/promo-1.png")}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5">
                      <i className="ni ni-settings-gear-65" />
                    </div>
                    <h3>Awesome features</h3>
                    <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-settings-gear-65" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Carefully crafted components
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-html5" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">Amazing page examples</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-satisfied" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Super friendly support team
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section> */}

          <section className="section bg-secondary">
            <Container>
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "Photo & Video Gallery",
                      tw: "相片及影片集",
                      cn: "相片及影片集",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="..."
                      src={require("assets_/img_/events/ground_breaking_photo.jpg")}
                      top
                    />
                    {/* <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Volunteer Work
                      </h4>
                      <p className="lead text-italic text-white">
                        Volunteer team contributes to the society in every summer.
                      </p>
                    </blockquote> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    <h3>
                      <Determinator>
                        {{
                          en: "coming soon...",
                          tw: "籌備中...",
                          cn: "筹备中...",
                        }}
                      </Determinator>
                    </h3>
                    {/* <p className="lead">
                      2020/09
                    </p>
                    <p>
                      <Determinator>
                        {{
                          en: "CLC Groundbreaking Ceremony",
                          tw: "社區聯絡中心動土儀式",
                          cn: "社区联络中心动土仪式",
                        }}
                      </Determinator>
                    </p> */}

                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section id="publications" className="section ">
            <Container>   
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "Publications",
                      tw: "出版刊物",
                      cn: "出版刊物",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>

              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card id="leaflet" className="bg-default shadow border-0">
                    {/* <a href={require("assets_/pdf/clc_naming_competition_with_form_20201020.pdf")} download> */}
                      <CardImg
                        alt="..."
                        src={require("assets_/img_/events/leaflet_clc_naming_competition_20201019.png")}
                        top
                      />                    
                      <blockquote className="card-blockquote">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="svg-bg"
                          preserveAspectRatio="none"
                          viewBox="0 0 583 95"
                        >
                          <polygon
                            className="fill-default"
                            points="0,52 583,95 0,95"
                          />
                          <polygon
                            className="fill-default"
                            opacity=".2"
                            points="0,42 583,95 683,0 0,95"
                          />
                        </svg>                        
                        <h4 className="display-3 font-weight-bold text-white">
                          <Determinator>
                            {{
                              en: "Leaflet",
                              tw: "傳單",
                              cn: "传单",
                            }}
                          </Determinator>
                        </h4>
                        
                        <p className="lead text-italic text-white">
                          {/* Volunteer team contributes to the society in every summer. */}
                        </p>
                      </blockquote>
                    {/* </a> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    
                    <h3>
                      <Determinator>
                        {{
                          en: "Leaflet",
                          tw: "傳單",
                          cn: "传单",
                        }}
                      </Determinator>
                    </h3>
                    <p className="lead">
                      2020/10
                    </p>
                    {/* <a href={require("assets_/pdf/clc_naming_competition_20201019.pdf")} download> */}
                    <a href={require("assets_/pdf/clc_naming_competition_with_form_20201020.pdf")} >
                      <p>
                        &nbsp;&nbsp;&nbsp;
                        <Determinator>
                          {{
                            en: "CLC Naming Competition",
                            tw: "社區聯絡中心命名比賽",
                            cn: "社区联络中心命名比赛",
                          }}
                        </Determinator>
                      </p>
                    </a>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLScHD68Sb8Q092D0PXN--EK4pHILLXaBwjKTtrBy1AquA_HW7w/viewform" target="_blank">
                      <p>
                        &nbsp;&nbsp;&nbsp;
                        <Determinator>
                          {{
                            en: "Online Application",
                            tw: "線上申請",
                            cn: "线上申请",
                          }}
                        </Determinator>
                      </p>
                    </a>

                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>

              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card id="newsletter" className="bg-default shadow border-0">
                    {/* <a href={require("assets_/pdf/clc_newsletter_01_20201019.pdf")} download> */}
                      <CardImg
                        alt="..."
                        src={require("assets_/img_/events/publication_newsletter_01_20201019.png")}
                        top
                      />                    
                      <blockquote className="card-blockquote">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="svg-bg"
                          preserveAspectRatio="none"
                          viewBox="0 0 583 95"
                        >
                          <polygon
                            className="fill-default"
                            points="0,52 583,95 0,95"
                          />
                          <polygon
                            className="fill-default"
                            opacity=".2"
                            points="0,42 583,95 683,0 0,95"
                          />
                        </svg>                        
                        <h4 className="display-3 font-weight-bold text-white">
                          <Determinator>
                            {{
                              en: "Newsletter",
                              tw: "通訊刊物",
                              cn: "通讯刊物",
                            }}
                          </Determinator>
                        </h4>
                        
                        <p className="lead text-italic text-white">
                          {/* Volunteer team contributes to the society in every summer. */}
                        </p>
                      </blockquote>
                    {/* </a> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    
                    <h3>
                      <Determinator>
                        {{
                          en: "Newsletter",
                          tw: "通訊刊物",
                          cn: "通讯刊物",
                        }}
                      </Determinator>
                    </h3>
                    <p className="lead">
                      2020/10
                    </p>
                    <a href={require("assets_/pdf/clc_newsletter_01_20201224.pdf")} >
                      <p>
                        &nbsp;&nbsp;&nbsp;
                        <Determinator>
                          {{
                            en: "CLC Officially Opened",
                            tw: "社區聯絡中心正式啟用",
                            cn: "社区联络中心正式启用",
                          }}
                        </Determinator>
                      </p>
                    </a>
                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>              

            </Container>
          </section>

          <section className="section bg-secondary">
            <Container>
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "Media Centre ",
                      tw: "新聞中心",
                      cn: "新闻中心",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    {/* <CardImg
                      alt="..."
                      src={require("assets_/img_/activities/i360_202004_steel_bridge_view1_4096.jpg")}
                      top
                    /> */}
                    {/* <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Volunteer Work
                      </h4>
                      <p className="lead text-italic text-white">
                        Volunteer team contributes to the society in every summer.
                      </p>
                    </blockquote> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    <h3>
                      <Determinator>
                        {{
                          en: "coming soon...",
                          tw: "籌備中...",
                          cn: "筹备中...",
                        }}
                      </Determinator>
                    </h3>
                    <p className="lead">
                      {/* 2020/08 */}
                    </p>
                    <p>
                      {/* <Determinator>
                        {{
                          en: "CLC Groundbreaking Ceremony",
                          tw: "社區聯絡中心動土儀式",
                          cn: "社区联络中心动土仪式",
                        }}
                      </Determinator> */}
                    </p>
                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section ">
            <Container>
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "Award & Accreditation",
                      tw: "獎項及認證",
                      cn: "奖项及认证",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    {/* <CardImg
                      alt="..."
                      src={require("assets_/img_/activities/i360_202004_steel_bridge_view1_4096.jpg")}
                      top
                    /> */}
                    {/* <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Volunteer Work
                      </h4>
                      <p className="lead text-italic text-white">
                        Volunteer team contributes to the society in every summer.
                      </p>
                    </blockquote> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    <h3>
                      <Determinator>
                        {{
                          en: "coming soon...",
                          tw: "籌備中...",
                          cn: "筹备中...",
                        }}
                      </Determinator>
                    </h3>
                    <p className="lead">
                      {/* 2020/08 */}
                    </p>
                    <p>
                      {/* <Determinator>
                        {{
                          en: "CLC Groundbreaking Ceremony",
                          tw: "社區聯絡中心動土儀式",
                          cn: "社区联络中心动土仪式",
                        }}
                      </Determinator> */}
                    </p>
                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* <section className="section pb-0 bg-gradient-warning">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-lg-2 ml-lg-auto" md="6">
                  <div className="position-relative pl-md-5">
                    <img
                      alt="..."
                      className="img-center img-fluid"
                      src={require("assets/img/ill/ill-2.svg")}
                    />
                  </div>
                </Col>
                <Col className="order-lg-1" lg="6">
                  <div className="d-flex px-3">
                    <div>
                      <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                        <i className="ni ni-building text-primary" />
                      </div>
                    </div>
                    <div className="pl-4">
                      <h4 className="display-3 text-white">Modern Interface</h4>
                      <p className="text-white">
                        The Arctic Ocean freezes every winter and much of the
                        sea-ice then thaws every summer, and that process will
                        continue whatever.
                      </p>
                    </div>
                  </div>
                  <Card className="shadow shadow-lg--hover mt-5">
                    <CardBody>
                      <div className="d-flex px-3">
                        <div>
                          <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                            <i className="ni ni-satisfied" />
                          </div>
                        </div>
                        <div className="pl-4">
                          <h5 className="title text-success">
                            Awesome Support
                          </h5>
                          <p>
                            The Arctic Ocean freezes every winter and much of
                            the sea-ice then thaws every summer, and that
                            process will continue whatever.
                          </p>
                          <a
                            className="text-success"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            Learn more
                          </a>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  <Card className="shadow shadow-lg--hover mt-5">
                    <CardBody>
                      <div className="d-flex px-3">
                        <div>
                          <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                            <i className="ni ni-active-40" />
                          </div>
                        </div>
                        <div className="pl-4">
                          <h5 className="title text-warning">
                            Modular Components
                          </h5>
                          <p>
                            The Arctic Ocean freezes every winter and much of
                            the sea-ice then thaws every summer, and that
                            process will continue whatever.
                          </p>
                          <a
                            className="text-warning"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            Learn more
                          </a>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>

            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section> */}
          {/* <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">The amazing Team</h2>
                  <p className="lead text-muted">
                    According to the National Oceanic and Atmospheric
                    Administration, Ted, Scambos, NSIDClead scentist, puts the
                    potentially record maximum.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/team-1-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Ryan Tompson</span>
                        <small className="h6 text-muted">Web Developer</small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="warning"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="warning"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="warning"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/team-2-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Romina Hadid</span>
                        <small className="h6 text-muted">
                          Marketing Strategist
                        </small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="primary"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="primary"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="primary"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/team-3-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Alexander Smith</span>
                        <small className="h6 text-muted">UI/UX Designer</small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="info"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="info"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="info"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/team-4-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">John Doe</span>
                        <small className="h6 text-muted">Founder and CEO</small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="success"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="success"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="success"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section> */}
          {/* <section className="section section-lg pt-0">
            <Container>
              <Card className="bg-gradient-warning shadow-lg border-0">
                <div className="p-5">
                  <Row className="align-items-center">
                    <Col lg="8">
                      <h3 className="text-white">
                        We made website building easier for you.
                      </h3>
                      <p className="lead text-white mt-3">
                        I will be the leader of a company that ends up being
                        worth billions of dollars, because I got the answers. I
                        understand culture.
                      </p>
                    </Col>
                    <Col className="ml-lg-auto" lg="3">
                      <Button
                        block
                        className="btn-white"
                        color="default"
                        href="https://www.creative-tim.com/product/argon-design-system-react?ref=adsr-landing-page"
                        size="lg"
                      >
                        Download React
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Container>
          </section> */}

        </main>
        <MultiLang lang={this.props.languageState.lang} />

      </>
    );
  }
}

export default Events;
